module.exports = __webpack_public_path__ + "img/selfie.19d3529e.png";